export default __webpack_public_path__ + "static/avatar-kayi-common-4-cover-c0133f4495a898a068572b18c8a13421.png";